module.exports = __webpack_public_path__ + "img/monitor_cover_sag.4a6ea869.png";